import * as React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Button, Modal, Space, Table, Tag } from "antd";
import moment from "moment";
import {
  antTableWrapperSx,
  defaultPaginatedTableProps,
  idTableColumn,
} from "./AntTableStyles";

export const InboundDocumentsTable = ({
  inbounds,
  pagination,
  page,
  setPage,
  loading,
  onRowClick,
  onDelete,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const columns = [
    idTableColumn({ title: "ID", dataIndex: "_id" }),
    {
      title: "Vendor",
      dataIndex: "vendor",
    },
    {
      title: "Warehouse",
      dataIndex: "warehouse",
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (type) => (
        <Tag color={type === "Returns" ? "orange" : "blue"}>{type}</Tag>
      ),
    },
    {
      title: "Direction",
      dataIndex: "direction",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <Tag
          color={
            status === "Received"
              ? "green"
              : status === "Cancelled"
                ? "red"
                : status === "Pending"
                  ? "gold"
                  : "blue"
          }
        >
          {(status || "").toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Created",
      dataIndex: "createdAt",
    },
    ...(onDelete
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) => (
              <Space>
                <Button
                  danger
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    Modal.confirm({
                      title: "Delete inbound?",
                      content: `This permanently deletes inbound ${String(record._id).slice(-6)} and its line items. Received stock is not reversed.`,
                      okText: "Delete",
                      okButtonProps: { danger: true },
                      onOk: () => onDelete(record._id),
                    });
                  }}
                >
                  Delete
                </Button>
              </Space>
            ),
          },
        ]
      : []),
  ];

  const data = (inbounds || []).map((row) => ({
    key: row._id,
    _id: row._id,
    vendor: row.vendor?.name || "N/A",
    warehouse: row.targetWarehouse?.name || "N/A",
    type: row.isRTO ? "Returns" : "Main",
    direction: row.direction,
    status: row.status,
    createdAt: row.createdAt ? moment(row.createdAt).format("lll") : "",
  }));

  return (
    <Box sx={antTableWrapperSx(isMobile)}>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        onRow={onRowClick ? (record) => ({ onClick: () => onRowClick(record) }) : undefined}
        pagination={defaultPaginatedTableProps({
          current: page,
          pageSize: parseInt(pagination?.limit || 100),
          total: pagination?.totalDocs,
          onChange: (nextPage) => setPage(nextPage),
          itemLabel: "records",
        })}
        scroll={{ x: isMobile ? 300 : 1100 }}
      />
    </Box>
  );
};

export default InboundDocumentsTable;
